import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-broadcast',
  templateUrl: './create-broadcast.component.html',
  styleUrls: ['./create-broadcast.component.scss']
})
export class CreateBroadcastComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
